import {Component, Input} from '@angular/core';
import {CustomDialogComponent} from "../../custom-dialog/custom-dialog.component";
import {EtablissementData} from "../../utils/data/etablissments-data";
import {MatDialog} from "@angular/material/dialog";
import {PersonsService} from "../../../services/persons.service";
import {
  AddContactComponent
} from "../../../pages/etablissement/mon-etablissement/components/personnel/add-contact/add-contact.component";
import {FlagService} from "../../services/flag.service";
import {FlagType} from "../../utils/enums";

@Component({
  selector: 'app-personnel-action',
  templateUrl: './personnel-action.component.html',
  styleUrl: './personnel-action.component.scss'
})
export class PersonnelActionComponent {
  @Input() data: any = undefined;
  @Input() column: any = undefined;


constructor(private dialog: MatDialog, private personService: PersonsService, private flag: FlagService) {

}

editDialog(): void {
  const dialogRef = this.dialog.open(AddContactComponent, {
    data: this.data
  })
  dialogRef.afterClosed().subscribe(value => {
    if (value) {
      this.personService.toggleRefreshData()
    }
  })
}

  deletePerson() {
    const dialogRef  = this.dialog.open(CustomDialogComponent, {
      data: {
        title: EtablissementData.monEtablissement.deletePersonDialog.title,
        description: EtablissementData.monEtablissement.deletePersonDialog.description,
        primaryLabel: EtablissementData.monEtablissement.deletePersonDialog.primaryButton,
        secondaryLabel: EtablissementData.monEtablissement.deletePersonDialog.secondButton,
      },
      maxWidth: '464px',
      autoFocus: false
    })
    dialogRef .afterClosed().subscribe(res => {
      if (res) {
        this.personService.deletePerson(this.data.id).subscribe( res => {
          this.personService.toggleRefreshData();
          this.flag.displayFlag('la suppression est effectuée avec succès !', FlagType.success)
        })
      }
    })
  }
}


